import { createSelector } from "redux-starter-kit";

export default createSelector(["auth.user"], (user: any): any => user);
